module.exports = __webpack_public_path__ + "static/media/romaine.7a83f057.webp";